var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalerisErrorNotFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 91,
    r: 63,
    strokeOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 43h58a9 9 0 0 1 9 9v75a9 9 0 0 1-9 9H68a9 9 0 0 1-9-9V52a9 9 0 0 1 9-9Z",
    fill: "currentColor",
    fillOpacity: 0.035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 43h58a9 9 0 0 1 9 9v75a9 9 0 0 1-9 9H68a9 9 0 0 1-9-9V52a9 9 0 0 1 9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 65h38M77 80h31M77 95h23M77 110h29",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 119,
    r: 29,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 119,
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 141 22 22",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 141 22 22",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 111,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 43,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 76h12m-6-6v12M40 151h10m-5-5v10",
    strokeOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalerisErrorNotFound);
export default __webpack_public_path__ + "static/media/globaleris-error-notFound.a5f610c7.svg";
export { ForwardRef as ReactComponent };